import { Injectable } from '@angular/core';

interface CookieOptions {
  domain?: string;
  path?: string;
  expires?: string;
  secure?: boolean;
  sameSite?: 'Lax' | 'Strict' | 'None';
}

@Injectable({
  providedIn: 'root'
})
export class CookieService {
  private readonly domain = '.monific.com'; // Asegura acceso desde todos los subdominios
  private readonly secureCookie = true;
  private readonly sameSite: 'Lax' | 'Strict' | 'None' = 'None'; // Cambiado a 'None' para permitir uso entre sitios con secure

  private getCookieExpiration(expireDays: number): string {
    const expires = new Date();
    if (expireDays > 0) {
      expires.setDate(expires.getDate() + expireDays);
    }
    return expires.toUTCString();
  }


  set(name: string, value: string, expireDays: number = 0, path: string = '/'): void {
    if (!name) throw new Error('El nombre de la cookie no puede estar vacío.');
    if (!value) throw new Error('El valor de la cookie no puede estar vacío.');

    const cookieOptions: CookieOptions = {
      domain: this.domain,
      path,
      expires: this.getCookieExpiration(expireDays),
      secure: this.secureCookie,
      sameSite: this.sameSite
    };

    const cookie = this.generateCookieString(name, value, cookieOptions);
    document.cookie = cookie;
  }

  get(name: string): string {
    if (!name) throw new Error('El nombre de la cookie no puede estar vacío.');

    const cookies = document.cookie.split('; ');
    const encodedName = encodeURIComponent(name);

    for (const cookie of cookies) {
      const [cookieName, cookieValue] = cookie.split('=');
      if (cookieName === encodedName) {
        return decodeURIComponent(cookieValue);
      }
    }

    return '';
  }

  remove(name: string, path: string = '/'): void {
    if (!name) throw new Error('El nombre de la cookie no puede estar vacío.');

    this.set(name, '', -1, path);
  }

  private generateCookieString(name: string, value: string, options: CookieOptions): string {
    const encodedName = encodeURIComponent(name);
    const encodedValue = encodeURIComponent(value);
    const cookieParts = [
        `${encodedName}=${encodedValue}`,
        options.domain && `domain=${options.domain}`,
        options.path && `path=${options.path}`,
        options.expires && `expires=${options.expires}`,
        options.secure && 'secure',
        options.sameSite && `samesite=${options.sameSite}`
    ];

    return cookieParts.filter(Boolean).join('; ');
  }
}
